module.exports = __webpack_public_path__ + "static/sub-services-8-f966ba0f2b7a53222d74e1c2efcb76b3.jpg";